import { useEffect, useState } from 'react';
import { API_RESULT_MODAL_EVENT, type ApiResultModalDetail } from '@/lib/apiResultModal';

export default function ApiResultModalHost() {
  const [payload, setPayload] = useState<ApiResultModalDetail | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      const ce = e as CustomEvent<ApiResultModalDetail>;
      if (ce.detail?.message) setPayload(ce.detail);
    };
    window.addEventListener(API_RESULT_MODAL_EVENT, handler);
    return () => window.removeEventListener(API_RESULT_MODAL_EVENT, handler);
  }, []);

  if (!payload) return null;

  const close = () => setPayload(null);
  const confirm = () => {
    const onDismiss = payload.onDismiss;
    setPayload(null);
    onDismiss?.();
  };
  const isSuccess = payload.success;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-3 bg-black/45"
      role="presentation"
      onClick={close}
    >
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="api-result-modal-title"
        className="w-full max-w-sm rounded-lg bg-white shadow-xl overflow-hidden animate-[apiModalIn_0.2s_ease-out]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`px-4 pt-5 pb-3 ${isSuccess ? 'bg-green-50' : 'bg-red-50'}`}>
          <div className="flex items-center gap-2.5">
            <i
              className={`text-xl leading-none ${
                isSuccess ? 'ri-checkbox-circle-fill text-green-600' : 'ri-close-circle-fill text-red-600'
              }`}
              aria-hidden
            />
            <h2
              id="api-result-modal-title"
              className={`text-base font-semibold ${isSuccess ? 'text-green-800' : 'text-red-800'}`}
            >
              {isSuccess ? 'Success' : 'Request failed'}
            </h2>
          </div>
        </div>
        <div className="px-4 py-2.5">
          <p className="text-sm text-gray-700 leading-relaxed">{payload.message}</p>
        </div>
        <div className="px-4 pb-5">
          <button
            type="button"
            onClick={confirm}
            className={`w-full py-2.5 rounded-lg text-sm font-semibold text-white ${
              isSuccess ? 'bg-green-500 hover:bg-green-600' : 'bg-red-500 hover:bg-red-600'
            }`}
          >
            OK
          </button>
        </div>
      </div>
      <style>{`
        @keyframes apiModalIn {
          from { opacity: 0; transform: scale(0.96); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
}
